import React from "react";
import { Drawer, List, ListItemButton, ListItemText, ListItemIcon, Box, Typography } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import ScheduleIcon from '@mui/icons-material/Schedule';

const drawerWidth = 240;

const Sidebar = ({ role }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const adminMenu = [
    { text: 'Booking Management', path: '/admin/booking-management', icon: <DashboardIcon /> },
    { text: 'Employee Management', path: '/admin/employee-management', icon: <PeopleIcon /> },
    { text: 'Quotation Management', path: '/admin/quotation-management', icon: <RequestQuoteIcon /> },
  ];

  const employeeMenu = [
    { text: 'Time Management', path: '/employee/time-management', icon: <ScheduleIcon /> },
    { text: 'Quotation Management', path: '/employee/quotation-management', icon: <RequestQuoteIcon /> },
  ];

  const menuItems = role === 'admin' ? adminMenu : employeeMenu;

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
          bgcolor: '#1a237e', // Dark blue specific to screenshot usually
          color: 'white'
        },
      }}
    >
      <Box sx={{ p: 2 }}>
        <Typography variant="h6" sx={{ color: 'white', fontWeight: 'bold' }}>
          COMPANY
        </Typography>
      </Box>
      <List>
        {menuItems.map((item) => {
            const isActive = location.pathname.startsWith(item.path);
            return (
                <ListItemButton 
                    key={item.text} 
                    onClick={() => navigate(item.path)}
                    selected={isActive}
                    sx={{
                        '&.Mui-selected': {
                            bgcolor: 'rgba(255, 255, 255, 0.1)',
                            borderLeft: '4px solid #4caf50' 
                        },
                        '&:hover': {
                            bgcolor: 'rgba(255, 255, 255, 0.05)'
                        }
                    }}
                >
                    <ListItemIcon sx={{ color: 'white' }}>
                        {item.icon}
                    </ListItemIcon>
                    <ListItemText primary={item.text} />
                </ListItemButton>
            );
        })}
      </List>
    </Drawer>
  );
};

export default Sidebar;
